import DolezitostAktEuPage from './DolezitostAktEuPage';

export default DolezitostAktEuPage;
